import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEvryComponent } from './simple-icons-evry.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEvryComponent ],
    exports:      [ SimpleIconsEvryComponent ],
    bootstrap:    []
})
export class SimpleIconsEvryModule {}
